// src/stone/illustrations/StonjiAgentIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiAgentIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96",
    width: "1em",
    height: "1em",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#20252A", d: "M0 0h96v96H0z" }),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M48 84.002a6 6 0 1 0 0-12 6 6 0 0 0 0 12" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M71.997 60.004V75H48v6h27.053a2.933 2.933 0 0 0 2.933-2.934V48h-6z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M75 81.005A3.002 3.002 0 1 0 75 75a3.002 3.002 0 0 0 0 6.004"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M71.997 60.004a12.005 12.005 0 0 0 0-24.002zM23.998 60.004a12.004 12.004 0 0 1 0-24.002z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M83.996 48A36.002 36.002 0 0 0 12 48h6a30.002 30.002 0 0 1 59.998 0z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M39 42a3 3 0 1 0 0-6 3 3 0 0 0 0 6M57 42a3 3 0 1 0 0-6 3 3 0 0 0 0 6M66 48c0 9.94-8.06 18-18 18s-18-8.06-18-18h6.07c0 6.587 5.343 11.93 11.93 11.93S59.93 54.587 59.93 48z"
        }
      )
    ]
  }
);
var StonjiAgentIllustration_default = StonjiAgentIllustration;

export {
  StonjiAgentIllustration,
  StonjiAgentIllustration_default
};
